import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ModalHeaderComponent,
  ModalFooterComponent,
  ModalComponent,
  ModalBodyComponent,
} from './modal.component';
export class ModalModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    ModalComponent,
    ModalHeaderComponent,
    ModalBodyComponent,
    ModalFooterComponent,
  ],
  imports: [CommonModule],
  exports: [
    ModalComponent,
    ModalHeaderComponent,
    ModalBodyComponent,
    ModalFooterComponent,
  ],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ModalModule_tsickle_Closure_declarations() {
/** @type {?} */
ModalModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ModalModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
